import { faExclamationSquare } from '@fortawesome/pro-solid-svg-icons/faExclamationSquare';
import { PropertySearchResult } from '@propertypal/shared/src/types/propertySearch';
import React, { FunctionComponent } from 'react';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../icons/FontAwesomeIcon';
import { Text } from '../typography';
import { LinkButton } from './AlternativeSearches.style';
import { Container } from './DidYouMean.syle';

interface Props {
  searchResult: PropertySearchResult;
  onClick: (term: string) => void;
}

const DidYouMean: FunctionComponent<Props> = (props) => {
  const theme = useTheme();

  return (
    <Container data-testid="did-you-mean">
      <Text fontWeight="bold" fontSize={24}>
        <FontAwesomeIcon icon={faExclamationSquare} color={theme.primary} style={{ marginRight: 8 }} />
        Did You Mean?
      </Text>

      {props.searchResult.alternativeSearches &&
        Object.keys(props.searchResult.alternativeSearches).map((key) => (
          <LinkButton fontSize={16} hover key={key} onClick={() => props.onClick(key)}>
            {key}
          </LinkButton>
        ))}
    </Container>
  );
};

export default DidYouMean;
